import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiHideProperty, ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { GendersList } from '@gtpl/shared-models/gtpl';

export class CreateUserDto {  
  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
  mobileNo:string;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  pin?:string;
  @ApiProperty({
    description: 'user role'
  })
  @IsNotEmpty({message:"Role should not be empty"})
  roleId:number;
  @ApiProperty()
  @ApiPropertyOptional()
  @ApiHideProperty()
  hierarchyId?:number;
  @ApiProperty({
    description:'user first name'
  })
  @MaxLength(500, { message: "FirstName allows maximum 500 characters" })
  @IsNotEmpty({message:"FirstName should not be empty"})
  firstName:string;
  @ApiProperty({
    description:'user last name'
  })
  @ApiPropertyOptional()
  @MaxLength(500, { message: "LastName Name allows maximum 500 characters" })
  lastName?: string;
  @ApiProperty({ enum: Object.values(GendersList) })
  @IsNotEmpty() gender: GendersList;
  @ApiProperty({description:'user date of birth'})
  @ApiPropertyOptional()
  dob?: Date;
  @ApiProperty()
  @ApiPropertyOptional()
  @MaxLength(500, { message: "Address allows maximum 500 characters" })
  address?: string;
  @ApiProperty({description:'user village from search'})
  @ApiPropertyOptional()
  villageId?: number;  
  @ApiProperty({description:'user email'})
  @ApiPropertyOptional()
  email?: string;
  @ApiProperty({description:'user created by'})
  @ApiPropertyOptional()
  @ApiHideProperty()
  userId?:number;
  @ApiProperty({default:true})
  status: boolean;
  @ApiProperty()
  @ApiPropertyOptional()
  @ApiHideProperty()
  lastLogin?: Date;
  createdAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  createdUser? : number;
  updatedAt : Date;
  updatedUser? : number;
  @ApiProperty({minimum:1,default:1})
  versionFlag : number;
}

export class UserDto {
  @ApiProperty()
  Id?: number;
  @ApiProperty()
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
  mobileNo:string;
  @ApiProperty()
  isPinSet:boolean;
  @ApiProperty()
  pin?:string;
  @ApiProperty()
  @IsNotEmpty({message:"Role should not be empty"})
  roleId:number;
  @ApiProperty()
  hierarchyId?:number;
  @ApiProperty()
  status: boolean;
  @ApiProperty()
  lastLogin?: Date;
  createdAt : Date;
  @ApiProperty()
  @IsOptional()
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  updatedUser : number;
  @ApiProperty()
  versionFlag : number;
  @ApiProperty()
  fcmToken:string;
}

export class UserBasicDto {
  @ApiProperty()
  userId:number;
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile number should be only numeric. " })
  mobileNo:string;
  @ApiProperty()
  roleId:number;
}

export class UserRoleDto {
  @ApiProperty()
  userId:number;
  @ApiProperty()
  roleId:number;
}

export class UserIdDto {
  @ApiProperty()
  userId:number;
}

export class SignUpDto {
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile number should be only numeric. " })
  mobileNo:string;
  @ApiProperty({
    description:'user first name'
  })
  @MaxLength(500, { message: "FirstName allows maximum 500 characters" })
  @IsNotEmpty({message:"FirstName should not be empty"})
  firstName:string;
}

export class LoginUserDto { 
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
  mobileNo:string;
  @ApiProperty()
  @IsNotEmpty()
  pin:string;
  @ApiProperty()
  fcmToken:string;
}

export class SetPinDto {
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
  mobileNo:string;
  @ApiProperty()
  @IsNotEmpty({message:"pin should not be empty"})
  pin:string;  
}

export class OtpDto {  
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
  mobileNo:string; 
}

export class VerifyOtpDto {  
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
  mobileNo:string;
  @ApiProperty({
    description: '4 digits otp number - type:integer'
  })
  @IsNotEmpty({message:"OTP should not be empty"})
  otp:number; 
}


export class userSearchDto {
  @ApiProperty()
  @IsNotEmpty({message:"search not empty"})
  searchTerm:string;
}


